module.exports = {"410871060":"李万街道","410871061":"文苑街道","410871062":"文昌街道","410871100":"阳庙镇","410871101":"宁郭镇","410871203":"苏家作乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410871.json
// module id = 1605
// module chunks = 0